import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import constant from "../store/constant.js";

Vue.use(VueRouter);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

const router = new VueRouter({
  routes: routes.data
});

router.beforeEach((to, from, next) => {
  if (
    window.localStorage.getItem("keep_limit") &&
    parseInt(window.localStorage.getItem("keep_limit")) !== 0
  ) {
    let date = new Date();
    let now = date.getTime();
    if (now > parseInt(window.localStorage.getItem("keep_limit"))) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      router.push("/login");
    } else {
      let keepLimit = date.getTime() + constant.keepLimit;
      window.localStorage.setItem("keep_limit", keepLimit);
    }
  }
  if (
    !to.matched.some(record => record.meta.noAuth) &&
    !window.localStorage.getItem("access_token")
  ) {
    next("/login");
  } else {
    next();
  }
  window.scrollTo(0, 0);
});

export default router;
